import { Shield, Eye, Warning as AlertTriangle, Lock, ArrowRight } from '@phosphor-icons/react';
import { Helmet } from 'react-helmet-async';
import { Breadcrumbs } from '@/components/seo/Breadcrumbs';
import { Link } from '@/lib/router-compat';
import { Card, CardContent } from '@/components/ui/card';


export default function AntiFrauda() {
  const canonicalUrl = 'https://roautomarket.ro/incredere/anti-frauda';

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Politica Anti-Fraudă | Cum te protejăm – RO Auto Market</title>
        <meta name="description" content="Mecanismele anti-fraudă ale RO Auto Market: verificare dealeri, detectare automată, raportare, protecție cumpărători." />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content="Politica Anti-Fraudă – RO Auto Market" />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="article" />
      </Helmet>

      <section className="surface-dark pt-4 pb-6 md:py-10 px-4">
        <div className="container mx-auto max-w-4xl">
          <Breadcrumbs items={[
            { label: 'Trust Center', href: '/incredere' },
            { label: 'Anti-Fraudă', href: '#' }
          ]} className="mb-6" />
          <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-4">Politica Anti-Fraudă</h1>
          <p className="text-lg text-muted-foreground">Cum prevenim frauda și protejăm cumpărătorii pe RO Auto Market.</p>
        </div>
      </section>

      <section className="py-12 px-4">
        <div className="container mx-auto max-w-4xl space-y-8">
          <div className="grid md:grid-cols-2 gap-6">
            {[
              { icon: Shield, title: 'Verificare RISCO obligatorie', desc: 'Fiecare dealer trece prin verificare automată a datelor de firmă. Firmele inactive sau radiate sunt blocate automat.' },
              { icon: Eye, title: 'Monitorizare activitate', desc: 'Sistemele noastre detectează automat comportamente suspecte: prețuri nerealiste, descrieri copiate, fotografii duplicate.' },
              { icon: AlertTriangle, title: 'Raportare și investigare', desc: 'Orice utilizator poate raporta un anunț suspect. Echipa noastră investighează în 24 de ore.' },
              { icon: Lock, title: 'Protecția datelor de contact', desc: 'Datele de contact sunt protejate. Accesul este logat și limitat pentru a preveni abuzul.' },
            ].map((item, i) => {
              const Icon = item.icon;
              return (
                <Card key={i}>
                  <CardContent className="p-6 flex items-start gap-4">
                    <div className="p-2 rounded-lg bg-primary/10">
                      <Icon className="w-6 h-6 text-primary" />
                    </div>
                    <div>
                      <h2 className="font-bold text-foreground mb-1">{item.title}</h2>
                      <p className="text-sm text-muted-foreground">{item.desc}</p>
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>

          <Card className="bg-destructive/5 border-destructive/20">
            <CardContent className="p-6">
              <h2 className="text-xl font-bold text-foreground mb-3">Semnale de alarmă</h2>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li>• Prețul este mult sub piață fără explicație</li>
                <li>• Vânzătorul refuză inspecția sau test drive-ul</li>
                <li>• Solicită plata anticipată sau prin metode neconvenționale</li>
                <li>• Fotografiile par luate de pe internet</li>
                <li>• Urgentarea exagerată a tranzacției</li>
              </ul>
            </CardContent>
          </Card>

          <div className="p-6 rounded-lg bg-muted/50">
            <h3 className="font-semibold text-foreground mb-3">Linkuri utile</h3>
            <div className="flex flex-wrap gap-3 text-sm">
              <Link to="/incredere/raporteaza-listare" className="flex items-center gap-2 text-primary hover:underline"><ArrowRight className="w-4 h-4" /> Raportează o listare</Link>
              <Link to="/incredere/verificare-dealeri" className="text-primary hover:underline">Verificare dealeri</Link>
              <Link to="/ghiduri/cum-verifici-istoricul-masinii" className="text-primary hover:underline">Verifică istoricul mașinii</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
